'use strict'

var hexParser = (color) => {
  if (/^#/.test(color)) {
    color = color.substr(1)
  }
  if (color.length !== 3 && color.length !== 6) {
    throw new Error(`Invalid color: "${color}"`)
  }
  if (color.length === 3) {
    return color
      .match(/^(.)(.)(.)$/)
      .slice(1)
      .map((val) => val.repeat(2))
  }

  return color.match(/^(.{2})(.{2})(.{2})$/).slice(1)
}

var isHex = (val) => {
  return /^[\da-f]+$/i.test(val)
}

var hexToDec = (vals) => {
  return vals.map((val) => {
    if (!isHex(val)) {
      throw new Error(`Invalid hexadecimal: "${val}"`)
    }

    return parseInt(val, 16)
  })
}

var decToHex = (vals) => {
  return vals.map((val) => {
    if (isNaN(val)) {
      throw new TypeError(`Invalid number: "${val}"`)
    }

    return val
      .toString(16)
      .padStart(2, '0')
  })
}

var handleVals = (vals, cb) => {
  return vals
    .map((val) => cb(val))
    .map((val) => {
      if (val > 255) return 255
      else if (val < 0) return 0
      else return Math.round(val)
    });
}

var handleHexColors = (color, cb) => {
  if (typeof color !== 'string') {
    throw new TypeError('"color" must be a string')
  }
  if (typeof cb !== 'function') {
    throw new TypeError('"cb" must be a function')
  }

  var parsed = hexParser(color)
  var decs = hexToDec(parsed)
  var newVals = handleVals(decs, cb)
  var newColor = '#' + decToHex(newVals).join("")

  return newColor
}

module.exports = handleHexColors